import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { profile } from '../data/profile';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Projects', to: '/projects' },
  { label: 'Experience', to: '/experience' },
  { label: 'Education', to: '/education' },
  { label: 'Awards', to: '/awards' },
  { label: 'Contact', to: '/contact' }
];

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className="header">
      <div className="container header__inner">
        <NavLink className="logo" to="/" aria-label="Navigate to home">
          <span className="logo__mark">VS</span>
          <span className="logo__text">{profile.personal.fullName}</span>
        </NavLink>
        <button
          className="nav-toggle"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          aria-controls="primary-nav"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="nav-toggle__bar" />
          <span className="nav-toggle__bar" />
          <span className="nav-toggle__bar" />
        </button>
        <nav
          className={menuOpen ? 'nav nav--open' : 'nav'}
          id="primary-nav"
          aria-label="Primary"
        >
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) =>
                isActive ? 'nav__link nav__link--active' : 'nav__link'
              }
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="header__cta">
          <a className="button button--primary" href={`mailto:${profile.personal.email}`}>
            Let&apos;s talk
          </a>
        </div>
      </div>
    </header>
  );
}
